import { Flex, VStack, Text, Button, Icon, Box, Divider } from '@chakra-ui/react';

import { IoArrowForwardCircle } from 'react-icons/io5';

import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';

import transformCouponDiscountString from '~/utils/transformCouponDiscountString';

import { Coupon } from '~/types/coupon';

type CouponItemProps = {
  coupon: Coupon & { storesName: Array<string> };
  onNavigate?: () => void;
  onViewDetail?: () => void;
};

export default function CouponItem({ coupon, onNavigate, onViewDetail }: CouponItemProps) {
  return (
    <Flex borderWidth="2px" borderColor="primaryLight" borderRadius="5px" position="relative">
      <VStack flex="1" align="flex-start" spacing={1} p={2}>
        <Text fontSize="sm" fontWeight="bold">
          {coupon.name}
        </Text>
        <Text fontSize="sm" color="gray.500">
          使用期限：{format(parseISO(coupon.endDate), 'yyyy/MM/dd')}
        </Text>
        <Text fontSize="sm" color="gray.500">
          適用店家：{coupon.storesName.join('、')}
        </Text>
        <Button
          size="xs"
          bgColor="gray.200"
          fontWeight="normal"
          color="gray.500"
          letterSpacing={1}
          _hover={{}}
          onClick={onViewDetail}
        >
          優惠券詳情
        </Button>
        <Divider />
        <Text fontSize="xs" fontWeight="bold" color="danger.600">
          {transformCouponDiscountString(coupon.type, coupon.condition)}
        </Text>
      </VStack>
      <VStack
        as="button"
        minW="5rem"
        p={2}
        justify="center"
        borderLeftWidth="2px"
        borderStyle="dashed"
        borderColor="primaryLight"
        position="relative"
        bgColor="#FFFBF5"
        onClick={onNavigate}
      >
        <Icon as={IoArrowForwardCircle} boxSize="2rem" color="secondary" />
        <Text color="secondary">點餐去</Text>

        {/** top concavity mask */}
        <Box
          w="1rem"
          h="1rem"
          bgColor="white"
          borderWidth="2px"
          borderRadius="full"
          borderColor="primaryLight"
          borderTopColor="transparent"
          borderLeftColor="transparent"
          transform="rotate(45deg)"
          position="absolute"
          top="-18px"
          left="-9px"
        />
        {/** bottom concavity mask */}
        <Box
          w="1rem"
          h="1rem"
          bgColor="white"
          borderWidth="2px"
          borderRadius="full"
          borderColor="primaryLight"
          borderBottomColor="transparent"
          borderRightColor="transparent"
          transform="rotate(45deg)"
          position="absolute"
          bottom="-9px"
          left="-9px"
        />
      </VStack>
    </Flex>
  );
}
